import api from '../services/api';

/**
 * Save a quotation for a specification
 * @param {FormData} quotationData - The quotation data
 * @returns {Promise<Object>} - API response
 */
export async function saveQuotation(quotationData) {
  try {
    // Convert FormData to object for logging (won't include files)
    const formDataObj = {};
    for (let [key, value] of quotationData.entries()) {
      // Don't try to log file objects, just their names
      if (value instanceof File) {
        formDataObj[key] = `File: ${value.name} (${value.size} bytes)`;
      } else {
        formDataObj[key] = value;
      }
    }
    // Debug log removed
    
    const response = await api.post('/api/quotations', quotationData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    // Debug log removed
    return response.data;
  } catch (error) {
    console.error('Error saving quotation:', error);
    // Capture response data if available
    if (error.response) {
      console.error('Error response status:', error.response.status);
      console.error('Error response data:', error.response.data);
      return {
        status: 0,
        message: (error.response.data && error.response.data.message) || 'Server error: ' + error.response.status,
        errors: (error.response.data && error.response.data.errors) || []
      };
    }
    return {
      status: 0,
      message: error.message || 'Failed to save quotation',
      errors: []
    };
  }
}

/**
 * Get evaluation details for a quotation
 * @param {number} quotationId - The quotation ID
 * @returns {Promise<Object>} - API response
 */
export async function getQuotationEvaluation(quotationId) {
  try {
    // Debug log removed
    const response = await api.get(`/api/quotations/${quotationId}`);
    // Debug log removed
    return response.data;
  } catch (error) {
    console.error('Error getting quotation evaluation:', error);
    return {
      status: 0,
      message: error.message || 'Failed to get quotation evaluation'
    };
  }
}

/**
 * Save evaluation for a quotation
 * @param {number} quotationId - The quotation ID
 * @param {Object} evaluationData - The evaluation data
 * @returns {Promise<Object>} - API response
 */
export async function saveEvaluation(quotationId, evaluationData) {
  try {
    // Convert to string to prevent JavaScript number precision loss with large IDs
    const response = await api.post(`/api/quotations/${String(quotationId)}`, evaluationData);
    // Debug log removed
    return response.data;
  } catch (error) {
    console.error('Error saving evaluation:', error);
    return {
      status: 0,
      message: error.message || 'Failed to save evaluation'
    };
  }
}
